export const aciDevice = {
    iconName: 'device',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M3.031 16V6.158c0-.307.146-.601.406-.818.26-.218.612-.34.979-.34h15.23c.368 0 .72.122.98.34.26.217.405.511.405.818V16M14.328 16a2.422 2.422 0 01-.969.732 3.348 3.348 0 01-1.328.268c-.466 0-.924-.092-1.328-.268A2.422 2.422 0 019.734 16H2.031v1c0 .53.281 1.04.781 1.415S3.991 19 4.698 19h14.667c.707 0 1.385-.21 1.885-.585s.781-.884.781-1.415v-1h-7.703z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M12.032 13a.25.25 0 110-.5M12.031 13a.25.25 0 000-.5',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                },
            },
            {
                attr: {
                    d: 'M16.031 9.415a6.361 6.361 0 00-8 0M9.699 11a3.71 3.71 0 014.666 0',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
